import { useEffect, useState } from 'react';
import { dashboardsService } from '@/services/dashboards.service';
import type { ProdutoCatalogo } from '@/types/dashboards';

let pedido: Promise<ProdutoCatalogo[]> | null = null;

/** Uma busca por sessão: o catálogo só muda quando o painel é atualizado (uma vez por dia). */
function buscarCatalogo(): Promise<ProdutoCatalogo[]> {
  if (!pedido) {
    pedido = Promise.resolve()
      .then(() => dashboardsService.getProdutosEquiplex())
      .catch((erro) => {
        pedido = null;
        throw erro;
      });
  }
  return pedido;
}

/** Só para os testes começarem sem o catálogo da anterior. */
export function esquecerCatalogoProdutos(): void {
  pedido = null;
}

export interface EstadoCatalogoProdutos {
  produtos: ProdutoCatalogo[];
  carregando: boolean;
  erro: boolean;
}

/** Catálogo do filtro de produto (todas as abas). Falhar não trava a tela: o filtro fica sem lista. */
export function useCatalogoProdutos(): EstadoCatalogoProdutos {
  const [estado, setEstado] = useState<EstadoCatalogoProdutos>({ produtos: [], carregando: true, erro: false });

  useEffect(() => {
    let vivo = true;
    buscarCatalogo()
      .then((produtos) => vivo && setEstado({ produtos, carregando: false, erro: false }))
      .catch(() => vivo && setEstado({ produtos: [], carregando: false, erro: true }));
    return () => {
      vivo = false;
    };
  }, []);

  return estado;
}
